export default __webpack_public_path__ + "static/media/harshit.88b397f8.jpg";